import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import txt from "src/config/search.json";
import { Container, IconButton, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";
import kml from "src/components/UI/LeftCard/assets/images/kml.png";
import url from "src/components/UI/LeftCard/assets/images/url.png";
import upload from "src/components/UI/LeftCard/assets/images/upload.png";
import stored from "src/components/UI/LeftCard/assets/images/local-storage.png";
import shapefile from "src/components/UI/LeftCard/assets/images/shapefile.png";
import json from "src/components/UI/LeftCard/assets/images/json.png";
import lat_long from "src/components/UI/LeftCard/assets/images/lat-long.png";
import export_ from "src/components/UI/LeftCard/assets/images/export.png";
import styles from "src/components/UI/LeftCard/assets/scss/search.module.scss";
import drawing from "src/components/UI/LeftCard/assets/images/drawing (1).png";
import printing from "src/components/UI/LeftCard/assets/images/printer.png";
import points from "src/components/UI/LeftCard/assets/images/search_points_.svg";
import line from "src/components/UI/LeftCard/assets/images/search_lines_.png";
import polygon from "src/components/UI/LeftCard/assets/images/polygon (2).png";
import convert from "src/components/UI/LeftCard/assets/images/lilo.png";
import service_area from "src/components/UI/LeftCard/assets/images/service-area.png";
import routing from "src/components/UI/LeftCard/assets/images/routing.png";
import geocoding from "src/components/UI/LeftCard/assets/images/geocoding.png";
import autocad from "src/components/UI/LeftCard/assets/images/autocad.png";
import fgdb from "src/components/UI/LeftCard/assets/images/fgdb.png";

// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface searchprops {
  queryStart: (state: boolean) => void;
}

interface Obj {
  title: string;
  value: string;
  tags: string[];
}

interface Objs {
  [key: string]: Obj[];
}
const iconDimensions: any = {
  "From KML": { width: "1.6rem", height: "1.6rem" },
  "From Service": { width: "1.4rem", height: "1.4rem" },
  "From File": { width: "1.35rem", height: "1.35rem" },
  "From Storage": { width: "1.35rem", height: "1.35rem" },
  "From Shapefile": { width: "1.55rem", height: "1.55rem" },
  "From GeoJSON": { width: "1.6rem", height: "1.6rem" },
  "Lat - Long": { width: "1.5rem", height: "1.5rem" },
  "Coordinates to point": { width: "1.5rem", height: "1.5rem" },
  "Web Scraping": { width: "1.55rem", height: "1.55rem" },
  Drawing: { width: "1.55rem", height: "1.55rem" },
  Points: { width: "1.55rem", height: "1.55rem" },
  Lines: { width: "1.55rem", height: "1.55rem" },
  Polygons: { width: "1.55rem", height: "1.55rem" },
  Printing: { width: "1.45rem", height: "1.45rem" },
  "Coordinates Converter": { width: "1.55rem", height: "1.55rem" },
  "Service Area": { width: "1.55rem", heigh: "1.55rem" },
  Routing: { width: "1.5rem", height: "1.5rem" },
  Geocoding: { width: "1.45rem", height: "1.45rem" },
  "From AutoCAD": { width: "1.4rem", height: "1.4rem" },
  "From FGDB": { width: "1.3rem", height: "1.4rem" },
};
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  borderRadius: "2rem",
  backgroundColor: "transparent",
  border: "0.15rem solid #acbcc5",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  color: "#acbcc5",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "red",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  left: "3rem",
  position: "relative",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    transition: theme.transitions.create("width"),
    width: "9.375rem",
    left: "-4rem",
    position: "relative",
  },
}));
const PrimarySearchAppBar = ({ queryStart }: searchprops) => {
  const dispatch = useDispatch();

  const [click, setclick] = React.useState(false);
  const [query, setQuery] = useState("");
  const [services, setServices] = useState<Objs>({});

  useEffect(() => {
    setServices(txt.services);
  }, []);

  useEffect(() => {
    if (click === false) {
      queryStart(false);
    } else {
      queryStart(true);
    }
  }, [click]);

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <div className={styles.inline}>
          {!click && (
            <div
              onClick={() => {
                setclick(true);
                dispatch(
                  appActions.setSearchString({
                    menu1: "",
                    menu2: "",
                    menu3: "",
                    menu4: "",
                    menu5: "",
                    menu6: "",
                  })
                );
              }}
              className={styles.circle}
            >
              {" "}
              <SearchIcon style={{ color: "#acbcc5" }} />{" "}
            </div>
          )}

          {click && (
            <Search className={styles.searchRoot}>
              <div className={styles.iconContainer}>
                <IconButton
                  className={styles.closeIcon}
                  onClick={() => {
                    setclick(false);
                    setQuery("");
                  }}
                >
                  <SearchIconWrapper>
                    <CloseIcon style={{ color: "#acbcc5", fontSize: "1rem" }} />
                  </SearchIconWrapper>
                </IconButton>
              </div>
              <StyledInputBase
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Search"
                inputProps={{ "aria-label": "search" }}
              />
            </Search>
          )}
        </div>
      </Box>
      {click && services && (
        <div className={styles.items}>
          {Object.keys(services).map((category) =>
            services[category]
              .filter((service) => {
                if (query === "" || service.title === "From PDF") {
                  return null;
                } else {
                  const lowerCaseQuery = query.toLowerCase();
                  return service.tags.some((tag) =>
                    tag.toLowerCase().includes(lowerCaseQuery)
                  );
                }
              })
              .map((service: any, index) => {
                return (
                  <Container className={styles.itemContainer} key={index}>
                    <IconButton
                      onClick={() =>
                        dispatch(
                          appActions.setSearchString({
                            menu1: service["ref"],
                            menu2: service["ref"],
                            menu3: service["ref"],
                            menu4: service["ref"],
                            menu5: service["ref"],
                            menu6: service["ref"],
                          })
                        )
                      }
                    >
                      <Icon classes={{ root: styles.innerIcon }}>
                        <img
                          src={
                            service.title === "From File"
                              ? upload
                              : service.title === "From Service"
                              ? url
                              : service.title === "From Storage"
                              ? stored
                              : service.title === "From KML"
                              ? kml
                              : service.title === "From Shapefile"
                              ? shapefile
                              : service.title === "From GeoJSON"
                              ? json
                              : service.title === "Lat - Long"
                              ? lat_long
                              : service.title === "Coordinates to point"
                              ? lat_long
                              : service.title === "Drawing"
                              ? drawing
                              : service.title === "Printing"
                              ? printing
                              : service.title === "Points"
                              ? points
                              : service.title === "Lines"
                              ? line
                              : service.title === "Polygons"
                              ? polygon
                              : service.title === "Coordinates Converter"
                              ? convert
                              : service.title === "Web Scraping"
                              ? export_
                              : service.title === "Routing"
                              ? routing
                              : service.title === "Service Area"
                              ? service_area
                              : service.title === "Geocoding"
                              ? geocoding
                              : service.title === "From AutoCAD"
                              ? autocad
                              : service.title === "From FGDB"
                              ? fgdb
                              : ""
                          }
                          style={iconDimensions[service.title] || {}}
                        />
                      </Icon>
                      <Typography
                        variant="h4"
                        color="white"
                        className={styles.itemTitle}
                      >
                        {service.title}
                      </Typography>
                    </IconButton>
                  </Container>
                );
              })
          )}
        </div>
      )}
    </div>
  );
};

export default PrimarySearchAppBar;
